import Vue from 'vue'
import Vuex from 'vuex'
import authorization from './modules/authorization'
import profile from './modules/profile'
import modalConfig from './modules/modalConfig'
import loader from './modules/loader'
import goalsAndDisplay from './modules/goalsAndDisplay'
import offerList from './modules/offerList'
import offerDetails from './modules/offerDetails'
import zonePriceEdit from './modules/zonePriceEdit'
import pendingApproval from './modules/pendingApprovals'
import selectedPendingApproval from './modules/selectedOfferList'
import dropdown from './modules/dropdown'
import landing from './modules/landing'
import approveWithChanges from './modules/approveWithChanges'
import chart from './modules/chart'
import fileUpload from './modules/fileUpload'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    authorization,
    profile,
    modalConfig,
    loader,
    goalsAndDisplay,
    offerList,
    offerDetails,
    zonePriceEdit,
    pendingApproval,
    selectedPendingApproval,
    dropdown,
    landing,
    approveWithChanges,
    chart,
    fileUpload
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js